"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var firstLeaderIcon_1 = __importDefault(require("./firstLeaderIcon"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var WithPlayers = function (_a) {
    var topPlayers = _a.topPlayers, emptyPlayers = _a.emptyPlayers, _b = _a.withFirstLeaderIcon, withFirstLeaderIcon = _b === void 0 ? false : _b;
    var t = (0, next_intl_1.useTranslations)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        topPlayers.map(function (item, idx) { return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.playerContainer, " ").concat(idx === 0 ? styles_module_scss_1.default.highlight : ''), key: String(item.user.userId) + idx },
            react_1.default.createElement("div", null,
                idx === 0 && withFirstLeaderIcon && react_1.default.createElement(firstLeaderIcon_1.default, null),
                idx + 1),
            react_1.default.createElement("div", null, item.user.nickname || t('translation.anonymous')),
            react_1.default.createElement("div", null, (item === null || item === void 0 ? void 0 : item.value)
                ? (0, apps_shared_1.convertThousands)(item === null || item === void 0 ? void 0 : item.value.toFixed(2))
                : (0, apps_shared_1.convertThousands)(Number((item === null || item === void 0 ? void 0 : item.totalSpent) || 0).toFixed(2) || 0)))); }),
        emptyPlayers.map(function (item, idx) { return (react_1.default.createElement("div", { key: "empty_player_".concat(idx) },
            react_1.default.createElement("div", null, item.number),
            react_1.default.createElement("div", null, "..."),
            react_1.default.createElement("div", null, "..."))); })));
};
exports.default = WithPlayers;
